export const calculateNewTimestampEndDay = (timestamp) => {
  if (timestamp) return 60000 * (60 * 24 - 1) + timestamp;
};
